<child-onboarding-container
  [formValid]="isFormValid$ | async"
  [loading]="store.sendingBankAccountInformation$ | async"
  (back)="service.goToPreviousStep()"
  (forward)="submit()"
>
  <p class="zero-text p-huge-med">{{ 'child-onboarding.bank-account.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'child-onboarding.bank-account.hint' | transloco }}</p>
  <web-design-system-input
    class="d-block mt-4"
    [label]="'child-onboarding.bank-account.account-holder' | transloco"
    [value]="name$ | async"
    [isValid]="name$ | async | notEmpty"
    (valueChange)="handleNameChange($event)"
  />
  <web-design-system-input
    class="d-block mt-4"
    [label]="'child-onboarding.bank-account.iban' | transloco"
    [isValid]="(iban$ | async | iban) && (ibanError$ | async) === null"
    [value]="iban$ | async"
    [error]="(iban$ | async | notEmpty) && (ibanError$ | async) ? (ibanError$ | async | transloco) : null"
    (valueChange)="handleIbanChange($event)"
    (handleBlur)="handleIbanBlur($event)"
  />
  @if (store.bankData$ | async; as bankData) {
    <div class="zero-text p-xsmall-reg mt-2">
      {{ 'child-onboarding.bank-account.bank-data' | transloco: { bankName: bankData.bankName, bic: bankData.bic } }}
    </div>
  }
  <a (click)="copy()" class="link-secondary font-default cursor-pointer">{{ 'child-onboarding.bank-account.copy-bank' | transloco }}</a>

  <web-design-system-notification class="d-block mt-4" [isDismissible]="false" color="green" size="small">
    <web-design-system-icon name="secure" /> {{ 'child-onboarding.bank-account.iban-ssl-notification' | transloco }}
  </web-design-system-notification>
</child-onboarding-container>
<div class="iban-notification-container">
  <web-design-system-notification
    color="blue"
    [headline]="'child-onboarding.bank-account.iban-notification.headline' | transloco"
    [isDismissible]="false"
  >
    {{ 'child-onboarding.bank-account.iban-notification.text' | transloco }}
  </web-design-system-notification>
</div>
